import React, {lazy, Suspense, useContext, useEffect} from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import LoadingSuspense from './components/common/LoadingSuspense';
import * as PATH from './routes/Slugs';
import PrivateRoute from './components/common/PrivateRoute';
import {AuthContext} from './contexts/AuthContextProvider';
import Interceptors from "./Interceptors";
import {GlobalContext} from "./contexts/GlobalContextProvider";

const DefaultLayout = lazy(() => import('./components/layout/DefaultLayout'));
const Login = lazy(() => import('./pages/login/Login'));
const SignUp = lazy(() => import('./pages/signup/SignUp'));
const OTPVerify = lazy(() => import('./pages/otp/OTPVerify'));
const ResetPassword = lazy(() => import('./pages/reset-password/ResetPassword'));
const ResetPasswordOTPVerify = lazy(() => import('./pages/reset-password/ResetPasswordOTP'));
const Page403 = lazy(() => import('./pages/error_pages/Page403'));
// const Page404 = lazy(() => import('./pages/error_pages/Page404'));
const Page500 = lazy(() => import('./pages/error_pages/Page500'));

const App = () => {

    const authContext = useContext(AuthContext);
    const globalContext = useContext(GlobalContext);

    useEffect(() => {
        globalContext.setScreenWidth(window.innerWidth);

        window.addEventListener('resize', updateDimensions);

        return () => {
            window.removeEventListener('resize', updateDimensions);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const updateDimensions = () => {
        globalContext.setScreenWidth(window.innerWidth);
    }

    return (
        <div className="app-wrapper">
            <Suspense fallback={<LoadingSuspense/>}>
                <BrowserRouter>
                    <Routes>
                        <Route path={PATH.LOGIN_PATH} element={<Login/>}/>
                        <Route path={PATH.SIGNUP_PATH} element={<SignUp/>}/>
                        <Route path={`${PATH.OTP_VERIFY_PATH}/:email`} element={<OTPVerify/>}/>
                        <Route path={PATH.RESET_PASSWORD_PATH} element={<ResetPassword/>}/>
                        <Route
                            path={`${PATH.RESET_PASSWORD_OTP_VERIFY_PATH}/:email`}
                            element={<ResetPasswordOTPVerify/>}
                        />
                        <Route element={<PrivateRoute isLogin={authContext.isLogin}/>}>
                            {/*<Route path={PATH.PAGE_404_PATH} element={<Page404/>}/>*/}
                            <Route path={PATH.PAGE_403_PATH} element={<Page403/>}/>
                            <Route path={PATH.PAGE_500_PATH} element={<Page500/>}/>
                            <Route path="*" element={<DefaultLayout/>}/>
                        </Route>
                    </Routes>
                    <Interceptors/>
                </BrowserRouter>
            </Suspense>
        </div>
    );

}

export default App;
